/**
 * Seeded pseudo-random number generator (Mulberry32)
 * Deterministic for procedural generation.
 */
export class SeededRandom {
  constructor(seed) {
    this.seed = seed | 0;
    this.state = seed | 0;
  }

  /** Returns a float in [0, 1) */
  next() {
    let t = (this.state += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  /** Float in [min, max) */
  range(min, max) {
    return min + this.next() * (max - min);
  }

  /** Integer in [min, max] inclusive */
  int(min, max) {
    return Math.floor(this.range(min, max + 1));
  }

  /** Pick a random element from an array */
  pick(arr) {
    return arr[this.int(0, arr.length - 1)];
  }

  /** Gaussian-ish distribution using Box-Muller */
  gaussian(mean = 0, stddev = 1) {
    const u1 = this.next();
    const u2 = this.next();
    const z0 = Math.sqrt(-2 * Math.log(u1 || 0.0001)) * Math.cos(2 * Math.PI * u2);
    return z0 * stddev + mean;
  }
}

/**
 * Hash a string to a 32-bit integer (FNV-1a)
 */
export function hashString(str) {
  let hash = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

/**
 * Create a seed from coordinates
 */
export function coordSeed(x, y, z = 0) {
  return hashString(`${x},${y},${z}`);
}
